import { FacebookShareTemplate } from '../templates/FacebookShareTemplate';
import { TwitterShareTemplate } from '../templates/TwitterShareTemplate';
import { LinkedinShareTemplate } from '../templates/LinkedinShareTemplate';
import { WhatsappShareTemplate } from '../templates/WhatsappShareTemplate';
import { TelegramShareTemplate } from '../templates/TelegramShareTemplate';
import { EmailShareTemplate } from '../templates/EmailShareTemplate';

export const shareButtonTemplatesEnum = {
    facebook: (pageTitle, pageUrl) => FacebookShareTemplate({ pageTitle, pageUrl }),
    twitter: (pageTitle, pageUrl) => TwitterShareTemplate({ pageTitle, pageUrl }),
    linkedin: (pageTitle, pageUrl) => LinkedinShareTemplate({ pageTitle, pageUrl }),
    whatsapp: (pageTitle, pageUrl) => WhatsappShareTemplate({ pageTitle, pageUrl }),
    telegram: (pageTitle, pageUrl) => TelegramShareTemplate({ pageTitle, pageUrl }),
    email: (pageTitle, pageUrl, body) => EmailShareTemplate({ pageTitle, pageUrl, body })
};
